import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Users } from "../Model/Users";
import { UserRepository } from "../Repository/UserRepository";

export interface GetusersUseCase {
  invoke: (page: number, pageSize: number, search: string) => Promise<PaginationResult<Users>>;
}

export class GetUsers implements GetusersUseCase {
  private userRepo: UserRepository;
  constructor(_UserRepo: UserRepository) {
    this.userRepo = _UserRepo;
  }

  async invoke(page: number, pageSize: number, search: string){
     
    const getData = await this.userRepo.getUsers(page, pageSize, search);
    return getData;
  }
}